<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <h4 class="modalTitle">Share</h4>
        <div class="selectorCnt" v-if="d">
          <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-facebook.png">
            <h4>Post</h4>
          </a>
          <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}&related=Amway,${d.category.name}`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-twitter.png">
            <h4>Tweet</h4>
          </a>
          <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
            target="_blank" class="selectorItem">
            <img src="../assets/i-wa.png">
            <h4>Send</h4>
          </a>
          <a :href="`mailto:?subject=${escapedTitleOnly}&body=${waText}`"
            target="_blank" class="selectorItem">
            <img src="../assets/envelope.png">
            <h4>Email</h4>
          </a>
          <div class="selectorItem" v-on:click="copyToClp(shareUriDisplay)">
            <img src="../assets/copy.png">
            <h4>Copy link</h4>
          </div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'confirmation',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      d: null,
      shareUri: '',
      shareEncoded: '',
      shareUriDisplay: '',
      escapedTitleOnly: '',
      escapedTitle: '',
      waText: '',
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.shareUri = `${this.$config.frontEnd}${d.category.slug}/${d.slug}`;
      this.shareUriDisplay = this.shareUri;
      this.shareEncoded = escape(this.shareUriDisplay);
      this.escapedTitle = escape(`${d.title} sudah terbit di`);
      this.escapedTitleOnly = escape(d.title);
      this.waText = escape(`${d.title} sudah terbit di ${this.shareUriDisplay}`);
      this.next = next;
      this.show = true;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      .modalTitle{
        padding: 20px 100px 10px;
        font-size: 28px;
        margin: -30px -80px 24px;
        background-color: #eee;
      }
      .selectorCnt{
        display: flex;
        .selectorItem{
          padding: 14px 20px 10px;
          border: #fff 1px solid;
          border-radius: 5px;
          transition: all .2s ease;
          position: relative;
          text-align: center;
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
          }
          img{
            height: 30px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
</style>
